// extracted by mini-css-extract-plugin
export default {"container":"AnnualSwitch_container__WZjnl","label":"AnnualSwitch_label__XIYxs"};